/*
 * Safety Wrapper for the vibration API, browsers not supporting the API
 * will simply do nothing at all.
 */

const vibrationAvailable =
  window.navigator && typeof window.navigator.vibrate === 'function';

export function vibrate(pattern: number | number[]) {
  if (vibrationAvailable) {
    window.navigator.vibrate(pattern);
  }
}
